import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';

/**
 * Custom missing translation handler that returns the translation key
 * when a translation is not found. This helps identify missing translations
 * during development and prevents fallback to other languages.
 */
export class SeuMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams): string {
    return `${params.key}`;
    // return `missing: ${params.key}`;
  }
}
